import get from 'lodash.get';
import sortBy from 'lodash.sortby';

export const getLicenseCustomFields = (product = {}, fields = []) => {
  const productFields = get(product, 'custom_fields', []);

  if (!Array.isArray(fields) || fields.length === 0) {
    return productFields.map((field) => ({
      ...field,
      isOnLicense: false,
      product_custom_field: field.id,
      license_custom_field_id: null,
    }));
  }

  const licenseFields = [];

  productFields.forEach((field) => {
    const licenseArr = fields.filter(
      (f) => f.product_custom_field === field.id,
    );
    const sortedArr = sortBy(licenseArr, 'id').reverse();
    const latestLicenseField = sortedArr[0];

    const licenseField = {
      ...field,
      isOnLicense: sortedArr.length > 0,
      product_custom_field: field.id,
      product_custom_field_enums: field.product_custom_field_enums || [],
      license_custom_field_id: latestLicenseField
        ? latestLicenseField.id
        : null,
      ...(latestLicenseField && { value: latestLicenseField.value }),
    };

    licenseFields.push(licenseField);
  });

  return licenseFields;
};
